import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Roles } from '@shs-digi-care-monorepo/interfaces';
import { DialogWrapperComponent } from '../dialog-wrapper/dialog-wrapper.component';
import { ShUserPickerComponent } from '@shs-digi-care-monorepo/frontend-lib';

export type AssignDialogData = Record<string, never>;
export interface AssignDialogResult {
    gid: string | null;
}

@Component({
    selector: 'app-assign-dialog',
    templateUrl: './assign-dialog.component.html',
    imports: [
        TranslateModule,
        RouterModule,
        ShUserPickerComponent,
        FormsModule,
        ReactiveFormsModule,
        DialogWrapperComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AssignDialog {
    private readonly dialogRef = inject<MatDialogRef<AssignDialog>>(MatDialogRef);
    public data = inject<AssignDialogData>(MAT_DIALOG_DATA);

    protected selectedUser: FormControl<string | null> = new FormControl<string | null>(null);
    protected rolesEnum: typeof Roles = Roles;

    public close(): void {
        this.dialogRef.close();
    }

    public confirm(): void {
        this.dialogRef.close({ gid: this.selectedUser.value });
    }
}
